import type { Observable as ObservableType } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { transformCard } from '../../model/issue/utils';
import type { Card } from '../../model/types';
import fetchCardData from '../../rest/card-load-graphql';
import { fetchIssue } from '../../rest/fetch-issue';
import { cardTransformer } from '../load-agility-graphql-data/transformer';
import type { ServiceContext } from '../service-context';

export function cardLoadService(
	serviceContext: ServiceContext,
	cardId: number,
	projectId: number,
): ObservableType<Card> {
	if (serviceContext.isCompanyManaged) {
		return fetchIssue(serviceContext.boardId, cardId).map(transformCard);
	}
	return fetchCardData('', serviceContext.boardId, cardId).map((cardData) =>
		cardTransformer(cardData, projectId),
	);
}
